import React from 'react';
import './ErrorDetailModal.css';

interface ErrorDetailModalProps {
  isOpen: boolean;
  errors: { row: number; error: string }[];
  warnings: { row: number; warning: string }[];
  detailReport: any;
  onClose: () => void;
}

const ErrorDetailModal: React.FC<ErrorDetailModalProps> = ({ isOpen, errors, warnings, detailReport, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-error-overlay">
      <div className="modal-error-container">
        <h3 className="modal-error-title">
          <i className="fas fa-info-circle"></i> Detalles de Carga
        </h3>

        {detailReport && (
          <div className="modal-detail-report">
            <h4>Resumen de elementos procesados:</h4>
            <ul className="detail-list">
              <li><strong>Categorías:</strong> {detailReport.categories.join(', ')}</li>
              <li><strong>Marcas:</strong> {detailReport.brands.join(', ')}</li>
              <li><strong>Proveedores:</strong> {detailReport.suppliers.join(', ')}</li>
              <li><strong>Sucursales:</strong> {detailReport.branches.join(', ')}</li>
            </ul>
          </div>
        )}

        {warnings.length > 0 && (
          <>
            <h4 className="warning-title"><i className="fas fa-exclamation-triangle"></i> Advertencias</h4>
            <ul className="modal-warning-list">
              {warnings.map((warning, index) => (
                <li key={index} className="warning-item">
                  <strong>Fila {warning.row}:</strong> {warning.warning}
                </li>
              ))}
            </ul>
          </>
        )}

        {errors.length > 0 && (
          <>
            <h4 className="error-title"><i className="fas fa-times-circle"></i> Errores</h4>
            <ul className="modal-error-list">
              {errors.map((error, index) => (
                <li key={index} className="error-item">
                  <strong>Fila {error.row}:</strong> {error.error}
                </li>
              ))}
            </ul>
          </>
        )}

        <button onClick={onClose} className="modal-error-close-btn">
          <i className="fas fa-times-circle"></i> Cerrar
        </button>
      </div>
    </div>
  );
};

export default ErrorDetailModal;
